import React, { useEffect, useRef  } from 'react';
import DrumKit from '../projects/DrumKit';
import PasswordGenerator from '../projects/PasswordGenerator';


interface ProjectPanelProps {
  isVisible: boolean;
  onToggle: () => void;
}

const ProjectPanel: React.FC<ProjectPanelProps> = ({ isVisible, onToggle } ) => {
  const panelRef = useRef<HTMLDivElement>(null);

  // Click outside to close
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(e.target as Node)) {
        onToggle();
      }
    };

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onToggle();
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEsc);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isVisible, onToggle]);

  return (
    <div className={`project-panel-overlay ${isVisible ? 'visible' : ''}`}>
      <div
        className={`project-panel ${!isVisible ? 'offscreen' : ''}`}
        id="project-panel"
        ref={panelRef}
      >
        <div className="game-panel">
          <div className="panel-header">
            <div>
              <p>Games/Projects Panel</p>
            </div>
            <button type="button" onClick={onToggle}>×</button>
          </div>

          <DrumKit />

          <div className="panelMd grey"><h4>Mini panel</h4></div>
          
          <PasswordGenerator />

          <div className="panelY-2 blue">
            <h4>Full-half panel</h4>
          </div>
          <div className="panelLg grey"><h4>Full panel</h4></div>
          <div className="panelFull blue"><h4>Medium panel</h4></div>
        </div>
      </div>
    </div>
  );
};

export default ProjectPanel;
